// Feature-flag gates for PWA/offline behavior, read from layout meta tags.
// Keep this module dependency-free so flag checks never pull in the sync engine.

export function isPwaEnabled() {
  const meta = document.querySelector('meta[name="pwa-enabled"]');
  return !!(meta && meta.content === 'true');
}

export function isCaseOfflineEnabled() {
  const meta = document.querySelector('meta[name="case-offline-enabled"]');
  return !!(meta && meta.content === 'true');
}
